import { IState } from '../../../../../store/types';
import { connect } from 'react-redux';
import { ContentLibraryFilters } from '../components/ContentLibraryFilters';
import { IContentLibraryFiltersEvents, IContentLibraryFiltersFields } from '../components/types';
import { ContentLibraryFiltersEvents } from './events';
import { ContentLibSelectors } from '../../../../../store/contentLib/selectors';
import { EContentLibViewMode } from '../../../../../store/contentLib/types';

const mapStateToProps = (
	dispatch: any
) => {
	return (
		state: IState
	): IContentLibraryFiltersFields => {
		const { level, text } = ContentLibSelectors.getSearchFilter(state);
		const viewMode = ContentLibSelectors.getViewMode(state);
		const isVideoList = viewMode === EContentLibViewMode.VIDEO_LIST;
		const isOpenCategories = ContentLibSelectors.isOpenCategories(state);
		const isCategoryId = !!ContentLibSelectors.getSelectedCategoryId(state);

		return {
			text,
			level,
			isVideoList,
			isOpenCategories,
			isCategoryId,
		}
	};
}

const mapDispatchToProps = (
	dispatch: any,
): IContentLibraryFiltersEvents => ({
	onChangeText: text => dispatch(ContentLibraryFiltersEvents.onTextChange(text)),
    onLevelChange: level => dispatch(ContentLibraryFiltersEvents.onLevelChange(level)),
	onOpenCategories: isOpen => dispatch(ContentLibraryFiltersEvents.onOpenCategories(isOpen)),
}
);

export const ContentLibraryFiltersHOC = connect(
	mapStateToProps,
	mapDispatchToProps
)(ContentLibraryFilters);

ContentLibraryFiltersHOC.displayName = 'ContentLibraryFiltersHOC';
